import './QueryInfoSkeleton.css'

export default function QueryInfoSkeleton() {
  return (
    <div className="query-info-skeleton skeleton-mode">
      <header id="query-info-header">
        <h1 className="query-title">
          <div className="skeleton-pulse text-block short" />
        </h1>
      </header>
      <section id="query-info">
        <div className="query-meta">
          <div className="skeleton-pulse subtitle" />
          <div className="skeleton-pulse subtitle" />
          <div className="skeleton-pulse subtitle" />
        </div>
        <div className="query-actions">
          <div className="skeleton-pulse subtitle" />
          <div className="skeleton-pulse subtitle" />
          <div className="skeleton-pulse subtitle" />
        </div>
      </section>
    </div>
  )
}
